/* ============================================================
   SMCL REVEAL · IntersectionObserver
   Activa las animaciones cuando el elemento entra en pantalla.
   Se ejecuta una sola vez por elemento (no re-anima al subir).
   Compatible con el editor de temas de Shopify (re-escanea al
   añadir/mover secciones).
   ============================================================ */
(function () {
  var SEL = '[data-smcl-reveal],[data-smcl-reveal-group]';

  function reveal(el) {
    el.classList.add('smcl-in');
  }

  // Si el navegador no soporta IntersectionObserver, mostramos todo.
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SEL).forEach(reveal);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      // Se dispara un poco antes de que el elemento llegue al centro,
      // igual que en SmclAlgo: el contenido ya está entrando al mirarlo.
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12
    }
  );

  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (!el.classList.contains('smcl-in')) observer.observe(el);
    });
  }

  // Primer escaneo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Editor de temas de Shopify: re-escanear al recargar una sección
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:select', function (e) { scan(e.target); });
})();
